import { render, staticRenderFns } from "./SatinalmaTopContent.vue?vue&type=template&id=62e50ede&"
import script from "./SatinalmaTopContent.vue?vue&type=script&lang=js&"
export * from "./SatinalmaTopContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports